import React from 'react';
import { Offcanvas } from 'react-bootstrap';

const FilterOffcanvas = ({ show, onHide, title = 'Filters', placement = 'end', bodyData }) => {
  return (
    <Offcanvas show={show} onHide={onHide} placement={placement}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>{bodyData}</Offcanvas.Body>
    </Offcanvas>
  );
};

export default FilterOffcanvas;
